import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const ColorPicker: StyleRule<{ expanded: boolean }> = ({
    theme,
    expanded,
}) => ({
    position: 'relative',
    fontSize: theme.siteVariables.fontSizes['caption03'],
    color: theme.siteVariables.colors.grey['300'],
    justifyContent: 'flex-start',
    paddingBottom: pxToRem(expanded ? 29 : 20),
    ['& .' + svgIconClassName]: {
        marginBottom: pxToRem(expanded ? 0 : 1),
    },
    alignContent: 'center',
    paddingTop: pxToRem(3),
});

export const SelectedColor: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: pxArrayToRem([32, 312]),
    columnGap: pxToRem(3),
    lineHeight: pxToRem(16),
    color: theme.siteVariables.colors.charcoal['250'],
    fontSize: pxToRem(16),
    letterSpacing: 'normal',
    justifyContent: 'flex-start',
    justifySelf: 'flex-start',
    alignItems: 'center',
    marginRight: 'auto',
});

export const Indicator: StyleRule<{ expanded: boolean }> = ({
    expanded,
    theme,
}) => ({
    position: 'absolute',
    top: expanded ? pxToRem(18) : '50%',
    right: pxToRem(18),
    transition: 'transform 150ms',
    transformOrigin: 'center',
    transform: expanded ? `rotate(180deg)` : `rotate(0deg)`,
    [`& .${svgIconClassName}`]: {
        display: 'block',
        marginBottom: 0,
        '& svg path': {
            fill: theme.siteVariables.colors.charcoal['250'],
        },
    },
});
